import { api } from './api'
import { AutomationRule, AutomationRuleFormData } from '../types/automationRule'

export const automationRuleService = {
  /**
   * Get all automation rules
   */
  getAll: async (): Promise<AutomationRule[]> => {
    const response = await api.get<AutomationRule[]>('/task-automation/rules')
    return response.data
  },

  /**
   * Get an automation rule by ID
   */
  getById: async (id: string): Promise<AutomationRule> => {
    const response = await api.get<AutomationRule>(`/task-automation/rules/${id}`)
    return response.data
  },

  /**
   * Create a new automation rule
   */
  create: async (data: AutomationRuleFormData): Promise<AutomationRule> => {
    const response = await api.post<AutomationRule>('/task-automation/rules', data)
    return response.data
  },

  /**
   * Update an automation rule
   */
  update: async (id: string, data: Partial<AutomationRuleFormData>): Promise<AutomationRule> => {
    const response = await api.put<AutomationRule>(`/task-automation/rules/${id}`, data)
    return response.data
  },

  /**
   * Delete an automation rule
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/task-automation/rules/${id}`)
  },

  /**
   * Toggle rule enabled/disabled status
   */
  toggle: async (id: string, enabled: boolean): Promise<AutomationRule> => {
    const response = await api.put<AutomationRule>(`/task-automation/rules/${id}/toggle`, { enabled })
    return response.data
  },

  /**
   * Test a rule against sample data
   */
  test: async (rule: AutomationRuleFormData, sampleData: any): Promise<{ matches: boolean; wouldCreateTask: any }> => {
    const response = await api.post<{ matches: boolean; wouldCreateTask: any }>('/task-automation/rules/test', {
      rule,
      sampleData,
    })
    return response.data
  },
}

